// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categories {
  padding: 48px 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.categories-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px 16px;
  margin-bottom: 24px;
}

.categories-title {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--text);
  letter-spacing: -0.3px;
}

.categories-all {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-family: inherit;
  font-size: 0.86rem;
  font-weight: 700;
  color: var(--p1);
  cursor: pointer;
  white-space: nowrap;
  transition: gap 0.2s, color 0.2s;
}
.categories-all:hover {
  color: var(--brand-700);
  gap: 10px;
}

/* Two featured big cards */
.cat-featured {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.cat-card-big {
  border: none;
  font-family: inherit;
  text-align: left;
  border-radius: 16px;
  padding: 28px 24px;
  min-height: 160px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  text-decoration: none;
  overflow: hidden;
  position: relative;
  transition: transform 0.2s, box-shadow 0.2s;
}
.cat-card-big:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.12); }

.cat-card-big-label {
  font-size: 1.25rem;
  font-weight: 800;
  color: #fff;
  letter-spacing: -0.3px;
}

.cat-card-big-sub {
  font-size: 0.82rem;
  font-weight: 600;
  color: #fff;
  margin-top: 4px;
}

.cat-card-big-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255,255,255,0.22);
  border: 1px solid rgba(255,255,255,0.35);
  border-radius: 20px;
  padding: 7px 14px;
  font-size: 0.82rem;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  width: fit-content;
  transition: background 0.2s;
}
.cat-card-big-btn:hover { background: rgba(255,255,255,0.32); }

.cat-deco {
  position: absolute;
  border-radius: 50%;
  background: rgba(255,255,255,0.09);
}
.cat-deco-1 { width: 120px; height: 120px; top: -30px; right: -30px; }
.cat-deco-2 { width: 80px; height: 80px; bottom: -20px; right: 60px; }

/* Small category chips carousel */
.cat-carousel {
  position: relative;
}

.cat-grid {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scroll-behavior: smooth;
  padding: 4px 2px 12px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.cat-grid::-webkit-scrollbar { display: none; }

.cat-carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--border);
  background: #fff;
  color: var(--text);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(0,0,0,0.12);
  transition: background 0.2s, transform 0.15s;
}
.cat-carousel-btn:hover { background: var(--p1); color: #fff; }
.cat-carousel-btn-prev { left: -6px; }
.cat-carousel-btn-next { right: -6px; }

.cat-chip {
  flex: 0 0 130px;
  scroll-snap-align: start;
  background: #fff;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
}
.cat-chip:hover {
  border-color: var(--p1);
  box-shadow: 0 4px 16px rgba(79,70,229,0.1);
  transform: translateY(-2px);
}

.cat-chip-icon {
  width: 46px;
  height: 46px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cat-chip-label {
  font-size: 0.8rem;
  font-weight: 700;
  color: var(--text);
  text-align: center;
}

@media (max-width: 600px) {
  .cat-featured { grid-template-columns: 1fr; }
  .cat-chip { flex-basis: 104px; }
  .cat-carousel-btn { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Categories.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,uBAAuB;EACvB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;AACA,sBAAsB,2BAA2B,EAAE,uCAAuC,EAAE;;AAE5F;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;AACA,0BAA0B,kCAAkC,EAAE;;AAE9D;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;AACpC;AACA,cAAc,YAAY,EAAE,aAAa,EAAE,UAAU,EAAE,YAAY,EAAE;AACrE,cAAc,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,WAAW,EAAE;;AAErE,kCAAkC;AAClC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA,+BAA+B,aAAa,EAAE;;AAE9C;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,uCAAuC;EACvC,4CAA4C;AAC9C;AACA,0BAA0B,qBAAqB,EAAE,WAAW,EAAE;AAC9D,yBAAyB,UAAU,EAAE;AACrC,yBAAyB,WAAW,EAAE;;AAEtC;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,+DAA+D;AACjE;AACA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,YAAY,iBAAiB,EAAE;EAC/B,oBAAoB,aAAa,EAAE;AACrC","sourcesContent":[".categories {\n  padding: 48px 20px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.categories-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n  margin-bottom: 24px;\n}\n\n.categories-title {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--text);\n  letter-spacing: -0.3px;\n}\n\n.categories-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  font-family: inherit;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: var(--p1);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: gap 0.2s, color 0.2s;\n}\n.categories-all:hover {\n  color: var(--brand-700);\n  gap: 10px;\n}\n\n/* Two featured big cards */\n.cat-featured {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.cat-card-big {\n  border: none;\n  font-family: inherit;\n  text-align: left;\n  border-radius: 16px;\n  padding: 28px 24px;\n  min-height: 160px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n  text-decoration: none;\n  overflow: hidden;\n  position: relative;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n.cat-card-big:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(0,0,0,0.12); }\n\n.cat-card-big-label {\n  font-size: 1.25rem;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: -0.3px;\n}\n\n.cat-card-big-sub {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #fff;\n  margin-top: 4px;\n}\n\n.cat-card-big-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(255,255,255,0.22);\n  border: 1px solid rgba(255,255,255,0.35);\n  border-radius: 20px;\n  padding: 7px 14px;\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  width: fit-content;\n  transition: background 0.2s;\n}\n.cat-card-big-btn:hover { background: rgba(255,255,255,0.32); }\n\n.cat-deco {\n  position: absolute;\n  border-radius: 50%;\n  background: rgba(255,255,255,0.09);\n}\n.cat-deco-1 { width: 120px; height: 120px; top: -30px; right: -30px; }\n.cat-deco-2 { width: 80px; height: 80px; bottom: -20px; right: 60px; }\n\n/* Small category chips carousel */\n.cat-carousel {\n  position: relative;\n}\n\n.cat-grid {\n  display: flex;\n  gap: 12px;\n  overflow-x: auto;\n  scroll-snap-type: x proximity;\n  scroll-behavior: smooth;\n  padding: 4px 2px 12px;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n.cat-grid::-webkit-scrollbar { display: none; }\n\n.cat-carousel-btn {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 2;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--border);\n  background: #fff;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(0,0,0,0.12);\n  transition: background 0.2s, transform 0.15s;\n}\n.cat-carousel-btn:hover { background: var(--p1); color: #fff; }\n.cat-carousel-btn-prev { left: -6px; }\n.cat-carousel-btn-next { right: -6px; }\n\n.cat-chip {\n  flex: 0 0 130px;\n  scroll-snap-align: start;\n  background: #fff;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 16px 14px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;\n}\n.cat-chip:hover {\n  border-color: var(--p1);\n  box-shadow: 0 4px 16px rgba(79,70,229,0.1);\n  transform: translateY(-2px);\n}\n\n.cat-chip-icon {\n  width: 46px;\n  height: 46px;\n  border-radius: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cat-chip-label {\n  font-size: 0.8rem;\n  font-weight: 700;\n  color: var(--text);\n  text-align: center;\n}\n\n@media (max-width: 600px) {\n  .cat-featured { grid-template-columns: 1fr; }\n  .cat-chip { flex-basis: 104px; }\n  .cat-carousel-btn { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
